import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Figma Schedule Blocks Horizontal (2061:7212 / 2061:7215) variants. */
export type EventqScheduleBlockVariant =
  | 'normal'
  | 'monitored-override'
  | 'non-monitored-override';

@Component({
  selector: 'eventq-schedule-block',
  templateUrl: './schedule-block.html',
  styleUrl: './schedule-block.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.eventq-schedule-block-host--normal]': "variant() === 'normal'",
    '[class.eventq-schedule-block-host--monitored-override]':
      "variant() === 'monitored-override'",
    '[class.eventq-schedule-block-host--non-monitored-override]':
      "variant() === 'non-monitored-override'",
  },
})
export class EventqScheduleBlock {
  readonly heading = input.required<string>();
  /** When omitted/empty, the time row is hidden (override blocks in Figma). */
  readonly time = input<string | null>(null);
  readonly variant = input<EventqScheduleBlockVariant>('normal');
}
